import { render, staticRenderFns } from "./SumUP.vue?vue&type=template&id=2cbb831f&"
import script from "./SumUP.vue?vue&type=script&lang=js&"
export * from "./SumUP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports